<template>
  <div class="row">
    <div class="col-12">
      <div class="poppins planned-content" style="margin-left: -20px;">
        <div class="mb-5" v-if="loaded">
          <BlockHeader name="Details" class="mt-0 ml-1" />
          <div class="row ml-0">
            <div class="col-lg-6 col-sm-12 col-xs-12" style="margin-left: 5px">
              <Select v-model="selectedYear" :onChange="init" :options="yearOptions" form-group-id="Year" placeholder="year" />
            </div>
          </div>
          <div v-for="key in Object.keys(names)" :key="key" class="row" :style="`${bottomOffset[key] ? 'margin-bottom:50px' : ''}`">
            <div class="line-value">
              <div style="width: 400px">
                {{ names[key] | i18n }}
              </div>
              <div style="width: 160px">
                <div>
                  <Input :value="Math.round(data[key])" :form-group-id="key" type="number" placeholder="" :bottom="0" :viewMode="true" />
                </div>
              </div>
              <span class="type-value">{{ types[key] }}</span>
            </div>
          </div>
        </div>
        <Loader v-else />
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import api from '../../../api';

import Input from '../../common/input';
import Select from '../../common/select';
import Loader from '../../common/loader';
import BlockHeader from '../../common/block-header';

const currentYear = Number(moment().format('YYYY'));

export default {
  title: 'Planned Values',
  components: { Input, Loader, BlockHeader, Select },
  data() {
    return {
      loaded: true,
      isSaving: false,
      selectedYear: currentYear,
      yearOptions: [],
      data: {},
      bottomOffset: {
        'Stickstoff N2': true,
      },
      types: {
        Hausmüll: 't/d',
        'Sperrmüll zu AVGR': 't/d',
        Sperrmüllrückführung: 't/d',
        'AWB zur RMVA': 't/d',
        'AWB gesamt': 't/d',
        'Sonstige + VV': 't/d',
        Sickerwasserkonzentrat: 't/d',
        'AVG-R': 't/d',
        REMONDIS: 't/d',
        'Sortierreste, ges': 't/d',
        'Fe-Schrott aus VSA': 't/d',
        'Input TMB': 't/d',
        'Input RMB': 't/d',
        Rostasche: 't/d',
        'Reste Reststoffe AGR': 't/d',
        Gips: 't/d',
        'Kalk (CaO)': 't/d',
        'AW (NH4OH)': 't/d',
        'Herdofenkoks HOK': 't/d',
        'Stickstoff N2': 't/d',
        Verbrennungsmenge: 't/h',
        Erdgas: 'm³/d',
        Heizöl: 'l/d',
        Strombezug: 'MWh/d',
        Wärmelieferung: 'MW',
        Stromlieferung: 'MW',
      },
      names: {
        Hausmüll: 'Household waste',
        'Sperrmüll zu AVGR': 'Bulky waste to AVGR',
        Sperrmüllrückführung: 'Bulky waste return',
        'AWB zur RMVA': 'AWB to the RMVA',
        'AWB gesamt': 'AWB total (household waste + bulky waste for AVGR)',
        'Sonstige + VV': 'Other + VV',
        Sickerwasserkonzentrat: 'Leachate concentrate',
        'AVG-R': 'AVG-R',
        REMONDIS: 'REMONDIS',
        'Sortierreste, ges': 'Sorting residues, total',
        'Fe-Schrott aus VSA': 'Fe scrap from VSA',
        'Input TMB': 'Input TMB',
        'Input RMB': 'Input RMB',
        Rostasche: 'Rust ash',
        'Reste Reststoffe AGR': 'Residues Residues AGR',
        Gips: 'Plaster',
        'Kalk (CaO)': 'Lime (CaO)',
        'AW (NH4OH)': 'AW (NH4OH)',
        'Herdofenkoks HOK': 'Hearth furnace coke HOK',
        'Stickstoff N2': 'Nitrogen N2',
        Verbrennungsmenge: 'Amount of combustion',
        Erdgas: 'Natural gas',
        Heizöl: 'Fuel oil',
        Strombezug: 'Electricity purchase',
        Wärmelieferung: 'Heat delivery',
        Stromlieferung: 'Electricity delivery',
      },
    };
  },

  async created() {
    const yearList = await api.year.get();
    this.yearOptions = yearList.data.map(({ year }) => year);
    this.selectedYear = localStorage.getItem('selectedYear') || currentYear;
    this.init();
  },
  methods: {
    async init() {
      localStorage.setItem('selectedYear', this.selectedYear);
      const response = await api.metrics.get({ year: this.selectedYear });
      this.data = response;
    },
  },
};
</script>

<style scoped lang="scss">
.planned-content {
  overflow-x: hidden;
}

.line-value {
  display: flex;
  margin-left: 35px;
  align-items: center;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
  margin-top: 20px;
  padding: 10px;
}

.type-value {
  margin-left: 10px;
  width: 90px;
}
</style>
